import React from 'react';

import { RichText } from 'src/components/RichText/RichText';

import classes from './CategoryList.scss';
import { CategoryListItems } from './CategoryListItems';

export interface CategoryItem {
    image: string;
    link: string;
    title: string;
    shortDescription: string | null;
}

type CategoryListProps = {
    title: string;
    titleElem?: 'h1' | 'h2';
    categories: CategoryItem[];
    description?: string | null;
};

export function CategoryList(props: CategoryListProps) {
    const { categories, title, titleElem, description } = props;
    return (
        <div className={classes.list} data-test-id="categoryList">
            {titleElem === 'h1' && (
                <h1 data-test-id="CategoryList__h1" className={classes.title}>
                    {title}
                </h1>
            )}
            {titleElem === 'h2' && (
                <h2 data-test-id="CategoryList__h2" className={classes.title}>
                    {title}
                </h2>
            )}
            {description && <CategoryDesc description={description} />}
            {/*<CategoryDesc description={'<p>Hey</p>'} />*/}
            {categories.length > 0 && <CategoryListItems categories={categories} />}
        </div>
    );
}

CategoryList.defaultProps = {
    titleElem: 'h1',
};

function CategoryDesc(props: { description: string }) {
    return (
        <div className={classes.desc}>
            <RichText content={props.description} />
        </div>
    );
}
